import React, { useState } from 'react';
import RiArrowDropDownLine from '@meronex/icons/ri/RiArrowDropDownLine';
import moment from 'moment';
import Modal from '../../Common/Modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OrderTrackingSteps = ['Processing', 'Order Placed', 'Shipped', 'Delivered'];
var statusMapping = {
  CANCELLED: 'Cancelled',
  CREATED: 'Order Placed',
  DISPATCHED: 'Shipped',
  DELIVERED: 'Delivered',
  PROCESSING: 'Processing'
};
var OrderCard = function OrderCard(_ref) {
  var _order$payment;
  var order = _ref.order,
    isExpanded = _ref.isExpanded,
    toggleExpanded = _ref.toggleExpanded;
  var currentStatus = statusMapping[order.rewardRedemptionStatus === 'CREATED' ? ((_order$payment = order.payment) === null || _order$payment === void 0 ? void 0 : _order$payment.paymentStatus) !== 'SUCCESS' ? 'PROCESSING' : 'CREATED' : order.rewardRedemptionStatus];
  var currentStatusIndex = OrderTrackingSteps.indexOf(currentStatus);
  var formattedDate = moment(order.createdOn).format('DD MMM YYYY');
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full lg:w-[95%] xl:w-[85%] flex flex-col bg-white border px-5  lg:px-2 xl:px-5 pt-5 border-gray-300 rounded-lg mb-5",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col lg:flex-row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex-shrink-0",
        children: /*#__PURE__*/_jsx("img", {
          className: "h-36 w-52 rounded-lg",
          src: order === null || order === void 0 ? void 0 : order.dealDisplayImageUrl,
          alt: ""
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col lg:px-4 lg:py-0 py-3 flex-grow",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center justify-between lg:mt-1",
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("h4", {
                className: "text-lg font-bold",
                children: order.dealTitle
              })
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex lg:mt-2",
          children: /*#__PURE__*/_jsxs("p", {
            className: "text-base font-semibold text-black",
            children: ["Amount Paid: \u20B999", ' ', /*#__PURE__*/_jsxs("span", {
              className: "text-gray-500",
              children: [' ', "(MRP: ", order.dealProductMrp, ")"]
            }), ' ']
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "overflow-x-auto scrollbar-thin py-3 lg:py-0",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex justify-start gap-6 mt-2 lg:mt-3 ",
            children: order.rewardRedemptionStatus === 'CANCELLED' ? /*#__PURE__*/_jsx("div", {
              className: "flex items-center",
              children: /*#__PURE__*/_jsx("div", {
                className: "italic text-sm text-red-600 font-semibold",
                children: /*#__PURE__*/_jsx("p", {
                  children: "Cancelled"
                })
              })
            }) : OrderTrackingSteps.map(function (step, index) {
              return /*#__PURE__*/_jsxs("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "italic text-sm whitespace-nowrap ".concat(currentStatusIndex >= index ? 'text-primary font-semibold' : 'text-gray-500'),
                  children: /*#__PURE__*/_jsx("p", {
                    children: step
                  })
                }), index < OrderTrackingSteps.length - 1 && /*#__PURE__*/_jsx("hr", {
                  className: "h-[2px] w-2 lg:w-2 xl:w-5 rounded ml-5 ".concat(currentStatusIndex > index ? 'bg-primary' : 'bg-[#B7B4CE]')
                })]
              }, index);
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "bg-gray-100 -mx-5 lg:-mx-2 xl:-mx-5 mt-4 rounded-b-lg p-4",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between text-sm",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-12",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-gray-500",
              children: "Ordered Date"
            }), /*#__PURE__*/_jsx("p", {
              className: "font-bold mt-1",
              children: formattedDate
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex items-center cursor-pointer",
            onClick: toggleExpanded,
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col mt-2",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-gray-500",
                children: "Ship to"
              }), /*#__PURE__*/_jsxs("p", {
                className: "font-bold flex items-center gap-1",
                children: [order.deliveryDetails.customerName ? order.deliveryDetails.customerName : order.userName, /*#__PURE__*/_jsx(RiArrowDropDownLine, {
                  className: "text-gray-500 h-8 w-6 transform ".concat(isExpanded ? 'rotate-180' : '')
                })]
              })]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col mt-2",
          children: [/*#__PURE__*/_jsxs("p", {
            className: "text-gray-500",
            children: ["Order :", ' ', order.deliveryDetails.trackingId ? order.deliveryDetails.trackingId : order.id]
          }), /*#__PURE__*/_jsx("p", {
            className: "font-bold mt-1"
          })]
        })]
      }), isExpanded && /*#__PURE__*/_jsxs("div", {
        className: "pl-[131px]",
        children: [/*#__PURE__*/_jsxs("p", {
          className: "text-sm text-gray-400",
          children: [order.deliveryDetails.shippingAddress.line1 && "".concat(order.deliveryDetails.shippingAddress.line1, ", "), order.deliveryDetails.shippingAddress.line2 && "".concat(order.deliveryDetails.shippingAddress.line2, ", "), order.deliveryDetails.shippingAddress.city && "".concat(order.deliveryDetails.shippingAddress.city, ", "), order.deliveryDetails.shippingAddress.state && "".concat(order.deliveryDetails.shippingAddress.state, ", "), order.deliveryDetails.shippingAddress.pincode && "".concat(order.deliveryDetails.shippingAddress.pincode, ", "), order.deliveryDetails.shippingAddress.country]
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-sm text-gray-400",
          children: ["Mobile :", ' ', /*#__PURE__*/_jsx("span", {
            className: "font-semibold text-black text-sm",
            children: order.deliveryDetails.mobileNumber
          })]
        })]
      })]
    })]
  });
};
export default OrderCard;